import * as React from "react";
import { FaBars, FaEdit, FaFileImage, FaTrash } from "react-icons/fa";
import { SortableHandle } from "react-sortable-hoc";
import ClickableElement from "../../../../utils/ClickableElement";
import ActionConfirmationButton from "../../ActionConfirmation";
import { ICourseInstructionContentPart } from "../../../../course-author/types";
import { isGridPart, isTeachingPart } from "./util";
import { isNil } from "ramda";
import { TooltipWrapper } from "../../../Analytics/FilterCriteria/FilterCriteria";
import { Container, DragSourceContainer, EditButton } from "./ControlBar.styles";

interface IControlBarProps {
  editing: boolean;
  showBackgroundOptions?: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onBackgroundClick?: () => void;
  part?: ICourseInstructionContentPart;
}

const SortBars = SortableHandle(() => <FaBars style={{ padding: "0.5rem" }} />);

export const ControlBar: React.FC<IControlBarProps> = props => (
  <Container>
    {!isNil(props.part) && (isTeachingPart(props.part) || isGridPart(props.part)) && (
      <ClickableElement onClick={props.onBackgroundClick}>
        <FaFileImage style={{ color: props.showBackgroundOptions ? "red" : "inherit" }} />
      </ClickableElement>
    )}
    <TooltipWrapper id="reorder-block" content="Reorder block">
      <DragSourceContainer>
        <SortBars />
      </DragSourceContainer>
    </TooltipWrapper>
    <ActionConfirmationButton ActionIcon={FaTrash} action="Delete" actionFn={props.onDelete} />
    <EditButton onClick={props.onEdit} aria-label="toggle-edit" style={{}}>
      <FaEdit style={{ color: props.editing ? "red" : "inherit" }} />
    </EditButton>
  </Container>
);
